<template>
  <div
    class="tooltip-container"
    :style="{background: `url('${imageUrl}')`}"
  >
    <div
      class="tooltip-content p-2"
    >
      <h3 class="m-0 text-truncate">{{ title }}</h3>
      <v-research-info
        :average="averageRating"
        :average-total="averageTotal"
        :number-of-reviews="numberOfReviews"
        :start-date="startDate"
        :end-date="endDate"
      />
      <v-research-status-badge
        :status="status"
        :show-icon="false"
        :full-width="true"
      />
    </div>
  </div>
</template>

<script>
import VueI18n from '@/i18n';
import ResearchInfo from '@/common/components/research/ResearchInfo.vue';
import ResearchStatusBadge from '@/common/components/research/ResearchStatusBadge.vue';

// The component is rendered independent from the base component;
const t = (key) => VueI18n.t(key);

export default {
  name: 'TimelineChartTooltip',
  components: {
    'v-research-info': ResearchInfo,
    'v-research-status-badge': ResearchStatusBadge,
  },
  props: {
    imageUrl: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    averageRating: {
      type: Number,
      required: false,
    },
    averageTotal: {
      type: Number,
      required: false,
    },
    numberOfReviews: {
      type: Number,
      required: true,
    },
    startDate: {
      type: Date,
      required: true,
    },
    endDate: {
      type: Date,
      required: true,
    },
    status: {
      type: String,
      required: true,
    },
  },
  computed: {
    averageRatingLabel() {
      return t('word.grade');
    },
    numberOfReviewsLabel() {
      return t('word.reviews');
    },
  },
};
</script>

<style scoped>
.tooltip-container {
  width: 300px;
  height: 200px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  box-sizing: border-box;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.tooltip-content {
  width: 300px;
  height: 200px;
  background: rgba(255, 255, 255, 0.9);
}
</style>
